import OrgLink from "../../components/Layout/OrganizersLink";

export default function MAKEMental({ children }) {
  return (
    <>
      <p>
        MAKE challenges one’s mental image of metal as it celebrates creativity, craftsmanship and
        the enduring allure of this versatile material. Joining forces with metalsmiths such as
        BAREMETAL studio, a diverse cadre of local artists, designers, and creative misfits are on a
        mission to redefine the possibilities of metal fabrication.
      </p>
      <p>
        Fabricated metal pieces often grace our lives in the form of stylish lifestyle items,
        captivating spatial installations and elegant furniture. Yet, the intricate work, dedication
        and artistry behind each creation often remain unseen and underappreciated.
      </p>
      <p>
        MAKE offers an array of works that not only showcase the diverse qualities of metal but also
        challenge the limits of what can be achieved with it. Committed to sustainable and
        responsible creation, the works also take a conscious approach to repurposing material
        offcuts, transforming waste into masterpieces.
      </p>
      {children}
      <div className="credits">
        In partnership with Nanyang Academy of Fine Arts, University of the Arts Singapore and
        Studiowongs, MAKE is presented at the NAFA Fashion Gallery, co-organised by{" "}
        <OrgLink name={"JABOC"} /> and <OrgLink name={"Hans"} />.
      </div>
    </>
  );
}
